var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.gender === 'female')?_c('i',{staticClass:"demo-icon icon-n-female"}):(_vm.gender === 'male')?_c('i',{staticClass:"demo-icon icon-n-male"}):_c('i',{staticClass:"demo-icon icon-n-female"})}
var staticRenderFns = []

export { render, staticRenderFns }